import { memo } from 'react';

import AppModal from '../../components/AppModal';

import CreateMeasurementsForm from './CreateMeasurementsForm';

function CreateMeasurementsModal({
  isOpen,
  formRef,
  submittable,
  handleCancel,
  handleConfirm,
  onChange,
  setCreateFormSubmittable
}) {
  return (
    <AppModal
      confirmButtonText="Create Measures"
      title="Create New Measurements"
      confirmButtonDisabled={!submittable}
      isOpen={isOpen}
      handleCancel={handleCancel}
      handleConfirm={handleConfirm}>
      <CreateMeasurementsForm
        className="py-4"
        formRef={formRef}
        onChange={onChange}
        setSubmittable={setCreateFormSubmittable}
      />
    </AppModal>
  );
}

export default memo(CreateMeasurementsModal);
